import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import { useRecordContext } from "react-admin";
import { NiyaazFormSection } from "../common/NiyaazFormSection";
import { NiyaazShowMemberList } from "./NiyaazShowMemberList";
import { NiyaazShowReceipts } from "./NiyaazShowReceipts";
import type { NiyaazShowRecord } from "./niyaaz-show-types";

const memberCountChip = (count: number, singular: string, plural: string) => (
  <Chip size="small" variant="outlined" label={`${count} ${count === 1 ? singular : plural}`} />
);

type NiyaazShowPeopleSectionProps = {
  isAshara: boolean;
};

export const NiyaazShowPeopleSection = ({ isAshara }: NiyaazShowPeopleSectionProps) => {
  const record = useRecordContext<NiyaazShowRecord>();
  const familyCount = record?.familyMembers?.length ?? 0;
  const mehmaanCount = record?.mehmaans?.length ?? 0;

  return (
    <Stack spacing={2}>
      <NiyaazFormSection
        title="Family Members"
        action={memberCountChip(familyCount, "member", "members")}
      >
        <NiyaazShowMemberList source="familyMembers" />
      </NiyaazFormSection>
      {isAshara ? (
        <NiyaazFormSection
          title="Mehmaans"
          action={memberCountChip(mehmaanCount, "mehmaan", "mehmaans")}
        >
          <NiyaazShowMemberList source="mehmaans" showJamaat showWhatsApp />
        </NiyaazFormSection>
      ) : null}
    </Stack>
  );
};

export const NiyaazShowReceiptsSection = () => (
  <NiyaazFormSection title="Receipts">
    <NiyaazShowReceipts />
  </NiyaazFormSection>
);
